import { Report } from '../../../../../services/reportServices'
import { ReportsTableRow } from './ReportsTableRow'

interface TableProps {
  reports: Report[]
  onRemoveUser: (id: string, name: Report['store']) => Promise<void>
  onEdit: (report: Report) => void
  onAddImages: (report: Report) => void
}

export function ReportsTable({ reports, onRemoveUser, onEdit, onAddImages }: TableProps) {
  if (reports.length === 0) {
    return (
      <div className="flex items-center justify-center w-full">
        <strong className="text-center">Nenhum relatório encontrado</strong>
      </div>
    )
  }

  return (
    <div
      className="overflow-x-auto mt-4 md:mt-2 w-full border border-slate-500 rounded-lg"
    >
      <table
        className="flex-1 w-full text-sm text-left rounded-t-md overflow-hidden"
      >
        <thead className="text-xs uppercase bg-primary_700 bg-opacity-80">
          <tr>
            <th
              scope="col"
              colSpan={2}
              className="px-4 py-3 min-w-48 text-center border-r border-slate-500"
            >
              Loja
            </th>
            <th
              scope="col"
              className="px-4 py-3  border-r border-slate-500 text-center"
            >
              Localização
            </th>
            <th
              scope="col"
              className="px-4 py-3  border-r border-slate-500 w-[6rem] text-center"
            >
              Última atualização
            </th>
            <th
              scope="col"
              className="px-4 py-3  border-r border-slate-500 w-[6rem] text-center"
            >
              Problema identificado
            </th>
            <th
              scope="col"
              className="px-4 py-3 w-16 text-center"
            >
              Ações
            </th>
          </tr>
        </thead>
        <tbody>
          {reports.map(report => (
            <ReportsTableRow
              key={report.id}
              report={report}
              onRemove={onRemoveUser}
              onEdit={onEdit}
              onAddImages={onAddImages}
            />
          ))}
        </tbody>
      </table>
    </div>
  )
}
